import { Modal, Box, Title, Text, Button } from '@nimbus-ds/components';
import { SubmitButton } from 'commons/components';
import { useToastStatus } from 'commons/hooks';
import {
  useOnboardingCreate,
  useTranslationDashboard,
} from 'domains/Dashboard/hooks';
import { trackingDashboardOnlineStoreActivateClick } from 'domains/Dashboard/tracking';

interface HelpOnlineStoreModalProps {
  open: boolean;
  onDismiss: () => void;
}

function HelpOnlineStoreModal({
  open,
  onDismiss,
}: Readonly<HelpOnlineStoreModalProps>) {
  const t = useTranslationDashboard('promote.helpOnlineStoreModal');
  const { handleCreateOnboarding, isError, isLoading } = useOnboardingCreate();

  useToastStatus({
    status: isError ? 'error' : 'idle',
    error: t('error'),
  });

  const handleConfirm = async () => {
    trackingDashboardOnlineStoreActivateClick('si');
    await handleCreateOnboarding();
    onDismiss();
  };

  const handleDismiss = () => {
    trackingDashboardOnlineStoreActivateClick('dismiss');
    onDismiss();
  };

  const handleDecline = () => {
    trackingDashboardOnlineStoreActivateClick('no');
    onDismiss();
  };

  return (
    <Modal open={open} onDismiss={handleDismiss}>
      <Modal.Header padding="none">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="4"
        >
          <Title as="h4" fontWeight="bold">
            {t('title')}
          </Title>
          <Text>{t('description')}</Text>
        </Box>
      </Modal.Header>
      <Modal.Footer>
        <Button
          appearance="neutral"
          onClick={handleDecline}
          disabled={isLoading}
        >
          {t('no')}
        </Button>
        <SubmitButton
          type="submit"
          onClick={handleConfirm}
          isLoading={isLoading}
          disabled={isLoading}
          appearance="primary"
        >
          {t('yes')}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
}

export default HelpOnlineStoreModal;
